import React from "react";
import { useState, useEffect } from "react";
import {

    getActiveMembers,
} from "../../services/ActivePrograms";
import Loader from "../../commonComponent/Loader";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import { useHover } from "../../customHook/useHover";

const ActiveMembersView = (props) => {
    const [filterdata, setFilterData] = useState([]);
    const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();

    const [isLoading, setLoader] = useState(true)
    const navigate = useNavigate()
    const programId = props.programId;
    useEffect(() => {
        getMembersById(); // eslint-disable-next-line
    }, [programId]);

    const getMembersById = async (searchWord) => {
        try {
            const response = await getActiveMembers(programId, searchWord);
           
            if (response.status === 200) {
                console.log(response.data.data, "membersss")
                const members = response?.data?.data[0]?.programMembers.map(item => {
                item.role = "Member";
                return item;
                });
        
                const careTeamMembers = response?.data?.data[0]?.careTeamMembers.map(item => {
                item.role = "Care Team";
                return item;
                });
        
                const allMembers = [...members, ...careTeamMembers].sort((a, b) => {
                    return new Date(b.date) - new Date(a.date);
                });
                
                setFilterData(allMembers);
                setLoader(false);

            } else {
                console.log(response?.data || response.message);
                 setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            error?.data?.data &&
                console.log(error?.data?.data || error.data?.message);
        }
    };

    const renderListRow = (item) => {
        // console.log(item.date, "item")
        return (
            <tr 
            className="pointer position-relative"
            onClick={() => {  
                if(item?.role === "Care Team"){
                    navigate(`/doctorviewprofile?doctorId=${item?._id?._id}`); 
                }
                else{
                    navigate("/allpatientinfo", {
                    state: { user: item._id },
                    });
                }
              }}
            >
                <td className="text-muted avatar_warper position-static "
                onMouseEnter={() => handleMouseEnter(item._id)}
                onMouseLeave={handleMouseLeave}
                ><SquareAvatar
                    src={item?._id?.profilePicture}
                    className="member_listimage squre_image2"
                /><AvatarPopover data={item._id} onHover={item._id === hoveredUserId}/></td>
                <td className="text-muted" >{(item?._id?.full_name.trim("")) ? item?._id?.full_name !== "undefined undefined" ? item?._id?.full_name : 'Anonymous' : 'Anonymous'}</td>
                <td className="text-muted">{item?.role}</td>
                <td className="text-muted">{item?.date ? format(parseISO(item?.date), 'MMM d, yyyy') : null}</td>
                {/* <td className="text-muted">Dec 1, 2022</td> */}

            </tr>
        )
    }

    const renderList = () => {
        return (
            <tbody>
                {filterdata?.map((item) => {
                    return renderListRow(item)
                })}
            </tbody>
        )
    }
    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                noAnyData={!(filterdata?.length > 0)}
                mainStyle={{height:'500px'}} />
                
        )
    }

    return (
        <div className="container">
            <div className="mt-4 px-2" style={{ height: "486px" }}>
                <div className="my-4">
                    <h2 className="chidHeadFont">Members</h2>
                </div>
                <div className="memlist_scroll mt-4 spacing_scroll">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <td className="py-4" >Photo</td>
                                <td className="py-4" >Member Name</td>
                                <td className="py-4" >Role</td>
                                <td className="py-4" >Date Added</td>
                                {/* <th className="py-4" scope="col text-secondary">Last Active</th> */}
                            </tr>
                        </thead>
                        {renderList()}
                    </table>
                    {!isLoading ? renderLoader() : null}
                </div>
            </div>
        </div>
    );
};

export default ActiveMembersView;
